import React, {useState, useRef} from 'react';
import AddressModal from "../../AddressModal/AddressModal";
import InfoModal from "../../InfoModal/InfoModal";
import {Link} from "react-router-dom";
import {Accordion} from "react-bootstrap";

const App3 = () => {

    const [showAddressModal, setShowAddressModal] = useState(false);

    const handleShowAddressModal = () => setShowAddressModal(true);
    const handleCloseAddressModal = () => setShowAddressModal(false);
    const modalRef = useRef();
    const modalRef2 = useRef();
    const modalRef3 = useRef();
    const photoVideoGuideTitle = "Участнику вступительных испытаний, проводимых ГГУ";

    const photoVideoGuide = (
        <div>
            <div>
                <h3>Памятка, для поступающих на творческие направления:</h3>

                <h4>На творческий экзамен по направлениям подготовки Специалитета необходимо иметь при себе:</h4>

                <p>На творческий экзамен по рисунку:</p>
                <ul>
                    <li>Бумагу форматом А2</li>
                    <li>Карандаши простые</li>
                    <li>Ластик</li>
                    <li>Кнопки канцелярские</li>
                    <li>Хорошее настроение</li>
                </ul>

                <p>На творческий экзамен по живописи:</p>
                <ul>
                    <li>Бумагу форматом А2</li>
                    <li>Краски на выбор (акварель, гуашь, темпера, акрил)</li>
                    <li>Кисти</li>
                    <li>Карандаши простые</li>
                    <li>Ластик</li>
                    <li>Кнопки канцелярские, баночка для воды, тряпочка</li>
                    <li>Хорошее настроение</li>
                </ul>

                <h4>На творческий экзамен по специальности «Скульптура» необходимо иметь при себе:</h4>

                <p>На творческий экзамен по рисунку:</p>
                <ul>
                    <li>Бумагу форматом А2</li>
                    <li>Карандаши простые</li>
                    <li>Ластик</li>
                    <li>Кнопки канцелярские</li>
                    <li>Хорошее настроение</li>
                </ul>

                <p>На творческий экзамен по скульптуре:</p>
                <ul>
                    <li>Стеки</li>
                    <li>Хорошее настроение</li>
                </ul>

                <p>На творческий экзамен по композиции:</p>
                <ul>
                    <li>Пластилин скульптурный 2 кг</li>
                    <li>Стеки</li>
                    <li>Проволочный каркас 12-15 см</li>
                    <li>Хорошее настроение</li>
                </ul>

                <h4>На творческий экзамен по специальности «Живопись и изящные искусства» необходимо иметь при себе:</h4>

                <p>На творческий экзамен по рисунку:</p>
                <ul>
                    <li>Бумагу форматом А2</li>
                    <li>Карандаши простые</li>
                    <li>Ластик</li>
                    <li>Кнопки канцелярские</li>
                    <li>Хорошее настроение</li>
                </ul>

                <p>На творческий экзамен по живописи:</p>
                <ul>
                    <li>Бумагу, картон форматом А2</li>
                    <li>Краски на выбор (акварель, гуашь, темпера, акрил)</li>
                    <li>Кисти</li>
                    <li>Карандаши простые</li>
                    <li>Ластик</li>
                    <li>Кнопки канцелярские, баночка для воды, тряпочка</li>
                    <li>Хорошее настроение</li>
                </ul>

                <p>На творческий экзамен по композиции:</p>
                <ul>
                    <li>Бумагу А2</li>
                    <li>по выбору акварель, гуашь, акрил</li>
                    <li>Линейку</li>
                    <li>Угольник</li>
                    <li>Циркуль</li>
                    <li>Карандаши</li>
                    <li>Кисти</li>
                    <li>Хорошее настроение</li>
                </ul>
            </div>
        </div>
    );

    const testingFeaturesTitle = "Особенности проведения тестирования";

    const testingFeatures = (
        <div>
            <h3>Особенности проведения тестирования:</h3>
            <ul style={{listStyle: 'decimal'}}>
                <li>На выполнение теста абитуриентам отводится 60 минут.</li>
                <li>Тестирование включает 20 заданий, каждое из которых содержит вопрос, требующий выбора
                    правильного ответа.</li>
                <li>Каждое правильно выполненное задание оценивается 5 баллами.</li>
            </ul>
            <h3>Во время экзамена запрещается:</h3>
            <ul>
                <li>громко разговаривать</li>
                <li>выходить из помещения без разрешения наблюдателя</li>
                <li>использовать любые технические средства в качестве шпаргалок</li>
                <li>производить фотосъемку работ</li>
                <li>использовать любые мобильные и цифровые устройства во время испытаний</li>
                <li>задерживать сдачу работы по истечении времени, отведённого на выполнение работы</li>
            </ul>
        </div>
    );

    const specialNeedsExamTitle = "Вступительные испытания для поступающих с ОВЗ и инвалидностью";

    const specialNeedsExam = (
        <div>
            <h3>Условия проведения вступительных испытаний для поступающих с ограниченными возможностями здоровья</h3>
            <p>
                Университет обеспечивает проведение вступительных испытаний для поступающих с ограниченными возможностями здоровья и (или) инвалидов с учетом их индивидуальных особенностей.
            </p>
            <p>
                Обеспечены условия беспрепятственного доступа в аудитории, туалеты и другие помещения.
            </p>
            <p>
                Вступительные испытания проводятся в отдельных аудиториях:
            </p>
            <ul>
                <li>письменная форма — не более 12 человек в аудитории;</li>
                <li>устная форма — не более 6 человек в аудитории.</li>
            </ul>
            <p>
                Допускается проведение в одной аудитории с другими поступающими, если это не мешает сдаче экзамена.
            </p>
            <p>
                В аудитории может присутствовать ассистент для технической помощи.
            </p>
            <p>
                Все условия предоставляются по заявлению с указанием необходимости специальных условий.
            </p>
            <p>
                Время экзамена может быть увеличено максимум на 1,5 часа.
            </p>
            <p>
                Поступающим предоставляется информация в доступной форме. Разрешено использовать технические средства.
            </p>

            <h4>Дополнительные условия в зависимости от особенностей:</h4>
            <ul>
                <li>
                    <strong>Слепые:</strong> задания — шрифт Брайля, электронные форматы или зачитывание ассистентом; выполнение — Брайль, компьютер или надиктовка.
                </li>
                <li>
                    <strong>Слабовидящие:</strong> освещение не менее 300 люкс, увеличивающие устройства, увеличенный шрифт.
                </li>
                <li>
                    <strong>Глухие и слабослышащие:</strong> звукоусиливающая аппаратура, услуги сурдопереводчика.
                </li>
                <li>
                    <strong>Слепоглухие:</strong> услуги тифлосурдопереводчика, а также требования для слепых и глухих.
                </li>
                <li>
                    <strong>Нарушения речи:</strong> устные испытания проводятся письменно.
                </li>
                <li>
                    <strong>Нарушения опорно-двигательного аппарата:</strong> задания выполняются на компьютере или надиктовываются; письменные испытания могут быть заменены устными.
                </li>
            </ul>
            <p>
                Вступительные испытания могут проходить с использованием дистанционных технологий.
            </p>
        </div>
    );

    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Вступительные испытания</h2>
            <p>Все вступительные испытания проводятся на <b>русском языке</b>.
                Проведение вступительного испытания на иностранном языке
                (за исключением вступительного испытания по иностранному языку) и на языке субъектов
                Российской Федерации при поступлении в ГГУ не предусмотрено.</p>
            <p>
                <h6>Университет проводит вступительные испытания:</h6>
                <ul>
                    <li>в рамках контрольных цифр приема очно</li>
                    <li>по договорам об оказании платных образовательных услуг очно или
                        с использованием дистанционных технологий.
                    </li>
                </ul>
                <h6>Минимальные баллы по общеобразовательным дисциплинам:</h6>
                <ul>
                    <li>русский язык – 40 баллов;</li>
                    <li>литература – 40 баллов;</li>
                </ul>
                <h6>Минимальные баллы по дополнительным вступительным испытаниям творческой и профессиональной направленности:</h6>
                <ul>
                    <li>рисунок – 60 баллов;</li>
                    <li>живопись – 60 баллов;</li>
                    <li>композиция – 60 баллов;</li>
                    <li>скульптура – 60 баллов;</li>
                </ul>
            </p>

            <p>
                <h3>Общеобразовательные вступительные испытания и вступительные испытания для поступающих на базе
                    профессионального образования проводятся:</h3>
                <ul>
                    <li>Для поступающих на бюджет с 21 июля по 25 июля {new Date().getFullYear()} г.</li>
                    <li>Для поступающих на платную основу с 11 августа по 19 августа {new Date().getFullYear()} г.</li>
                </ul>
            </p>

            <p>
                <b>Место проведения вступительных испытаний:</b> Московская область, Раменский городской округ, пос.
                Электроизолятор, д. 67
                (<Link to="#" onClick={(e) => {
                e.preventDefault();
                handleShowAddressModal();
            }}>
                как добраться
            </Link>)
            </p>
            <AddressModal show={showAddressModal} onHide={handleCloseAddressModal} showRepresentation={false}/>
            <p>
                На экзамене при себе необходимо иметь паспорт для идентификации Вашей личности, а
                также шариковую ручку.
                На дополнительных вступительных испытаниях творческой и профессиональной направленности Вам необходимо
                принести{" "}
                <Link to="#" onClick={(e) => {
                    e.preventDefault();
                    modalRef.current.openModal();
                }}>
                    следующие принадлежности
                </Link>.
            </p>
            <InfoModal
                ref={modalRef}
                title={photoVideoGuideTitle}
                description={photoVideoGuide}
            />

            <InfoModal
                ref={modalRef2}
                title={testingFeaturesTitle}
                description={testingFeatures}
            />

            <InfoModal
                ref={modalRef3}
                title={specialNeedsExamTitle}
                description={specialNeedsExam}
            />

            <p>
                <ul>
                    <li>
                        <a
                            href="/pdf/spec_spo_2025.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Вступительные испытания на базе профессионального образования (СПО, НПО)
                        </a>
                    </li>
                    <li>
                        <li>
                            <a
                                href="/pdf/spec_2025.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Общеобразовательные вступительные испытания
                            </a>
                        </li>
                    </li>
                    <li>
                        <Link to="#" onClick={(e) => {
                            e.preventDefault();
                            modalRef3.current.openModal();
                        }}>
                            Вступительные испытания для поступающих с ОВЗ и инвалидностью
                        </Link>
                    </li>
                </ul>
            </p>
            <p>
                <h5>Программы вступительных испытаний, проводимых организацией самостоятельно:</h5>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>При приеме на специалитета (по общеобразовательным
                            предметам)</Accordion.Header>
                        <Accordion.Body>
                            <h6>Вступительные испытания по общеобразовательным предметам проводятся в форме {" "}
                                <Link to="#" onClick={(e) => {
                                    e.preventDefault();
                                    modalRef2.current.openModal();
                                }}>
                                    тестирования
                                </Link></h6>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%B8%D0%B9.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по русскому языку
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/matem.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по математике
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9B%D0%B8%D1%82%D0%B5%D1%80%D0%B0%D1%82%D1%83%D1%80%D0%B0.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по литературе
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/hist.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по истории России
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%B3%D0%B5%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по географии
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/ikt.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по информатике и
                                        информационно-коммуникационным технологиям
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/obshestvo.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по обществознанию
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%90%D0%BD%D0%B3%D0%BB%D0%B8%D0%B9%D1%81%D0%BA%D0%B8%D0%B9%20%D1%8F%D0%B7%D1%8B%D0%BA.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по английскому языку
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/download/h34wc47uz2imael.doc"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по биологии
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>При приеме на специалитет (по вступительным испытаниям творческой
                            /профессиональной направленности)</Accordion.Header>
                        <Accordion.Body>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/prog_kp.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по конституционному праву
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/prog_tgp.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по теории государства и права
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%D0%BF%D0%BE%20%D0%A4%D0%9A%20%D0%92%D0%9E%202022%20%D0%B3..pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по физической культуре
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Hud_bak.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по рисунку и живописи
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%20%D0%B2%D1%81%D1%82%D1%83%D0%BF%D0%B8%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D1%85%20%D0%B8%D1%81%D0%BF%D1%8B%D1%82%D0%B0%D0%BD%D0%B8%D0%B9%20%D0%BF%D0%BE%20%D0%BC%D0%B0%D1%82%D0%B5%D0%BC%D0%B0%D1%82%D0%B8%D0%BA%D0%B5%20(%D0%BF%D1%80%D0%BE%D1%84%D0%B5%D1%81%D1%81%D0%B8%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D0%B9).pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по математике (профессиональной)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%20%D0%B2%D1%81%D1%82%D1%83%D0%BF%D0%B8%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D1%85%20%D0%B8%D1%81%D0%BF%D1%8B%D1%82%D0%B0%D0%BD%D0%B8%D0%B9%20%D0%BF%D0%BE%20%D0%BE%D1%81%D0%BD%D0%BE%D0%B2%D0%B0%D0%BC%20%D1%8D%D0%BA%D0%BE%D0%BD%D0%BE%D0%BC%D0%B8%D0%BA%D0%B8.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по основам экономики
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%20%D0%93%D0%B5%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F%20%D1%82%D1%83%D1%80%D0%B8%D0%B7%D0%BC%D0%B0.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по географии туризма
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%20%D0%98%D1%81%D1%82%D0%BE%D1%80%D0%B8%D1%8F%20%D0%BE%D1%82%D0%B5%D1%87%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D0%BE%D0%B9%20%D0%BA%D1%83%D0%BB%D1%8C%D1%82%D1%83%D1%80%D1%8B.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по истории отечественной культуры
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%20%D0%9E%D1%80%D0%B3%D0%B0%D0%BD%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F%20%D0%A1%D0%9A%D0%94.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по организации социально-культурной
                                        деятельности
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9E%D1%81%D0%BD%D0%BE%D0%B2%D1%8B%20%D0%BF%D1%81%D0%B8%D1%85%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D0%B8.%20%D0%A1%D0%BC%D0%B8%D1%80%D0%BD%D0%BE%D0%B2.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по основам психологии
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9E%D1%81%D0%BD%D0%BE%D0%B2%D1%8B%20%D0%BF%D0%B5%D0%B4%D0%B0%D0%B3%D0%BE%D0%B3%D0%B8%D0%BA%D0%B8.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по основам педагогики
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%20%D0%9E%D1%80%D0%B3%D0%B0%D0%BD%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F%20%D1%82%D1%83%D1%80%D0%B8%D1%81%D1%82%D1%81%D0%BA%D0%BE%D0%B9%20%D0%B8%D0%BD%D0%B4%D1%83%D1%81%D1%82%D1%80%D0%B8%D0%B8.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по организации туристской индустрии
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/istisk_bak.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        Программа вступительных испытаний по истории искусств
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Варианты вступительных испытаний прошлых лет</Accordion.Header>
                        <Accordion.Body>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/?param=infa&sub=osob_obsh" target="_blank"
                                       rel="noopener noreferrer">
                                        Особенности проведения тестирования по обществознанию
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/download/qi36dbdut6is2t8.doc" target="_blank"
                                       rel="noopener noreferrer">
                                        Особенности проведения тестирования по математике
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/?param=infa&sub=osob_ist" target="_blank"
                                       rel="noopener noreferrer">
                                        Особенности проведения тестирования по истории
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/?param=infa&sub=osob_russ" target="_blank"
                                       rel="noopener noreferrer">
                                        Особенности проведения тестирования по русскому языку
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/?param=infa&sub=osob_liter" target="_blank"
                                       rel="noopener noreferrer">
                                        Особенности проведения тестирования по литературе
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </p>
        </div>
    );
}

export default App3;